import React from 'react';
import {
  EntityType,
  Policyholder,
} from '@qover-private/protos-web/qover/dojo/contracts/v1/policyholder';
import { I18n } from '@lingui/react';
import { SummaryCard } from './SummaryCard';
import messages from './summaryPolicyholder.messages';

type SummaryPolicyholderProps<T> = {
  policyholder?: T;
  modifyTo: string;
  renderBefore?: () => JSX.Element;
  summaryCardStyle?: React.CSSProperties;
};

export function SummaryPolicyholder<T extends Policyholder>(
  props: SummaryPolicyholderProps<T>,
) {
  return (
    <I18n>
      {({ i18n }) => (
        <SummaryCard
          title={messages.thePolicyholder}
          data-test="general.summaryPolicyholder.modifyButton"
          modifyTo={props.modifyTo}
          style={props.summaryCardStyle}
        >
          {props.renderBefore && props.renderBefore()}
          {props.policyholder?.entityType === EntityType.ENTITY_TYPE_COMPANY
            ? messages.company(props.policyholder)
            : messages.person(i18n, props.policyholder)}
          {messages.address(i18n, props.policyholder?.address)}
          {props.policyholder?.entityType === EntityType.ENTITY_TYPE_COMPANY &&
            messages.companyContact(i18n, props.policyholder)}
          {props.policyholder?.entityType === EntityType.ENTITY_TYPE_COMPANY &&
            props.policyholder?.billingAddress &&
            messages.billingAddress(i18n, props.policyholder?.billingAddress)}
        </SummaryCard>
      )}
    </I18n>
  );
}
